<template>
    <!-- 전체 콘텐츠 영역 -->
    <div class="main-contents">
        <div class="news_wrap">
          <div class="path">커뮤니티 > 그레이트프로 뉴스</div>
          <div class="title_wrap">
            <h2>그레이트프로 뉴스</h2>
          </div>
          <!-- list -->
          <div class="news-list">
            <ul v-if="newsList.length > 0">
              <li v-for="(news, index) in newsList" :key="news.newsCenterSeq">
                <a @click="goNewsDetail(news.newsCenterSeq)">
                  <span class="numb">{{(pageInfo.pageUnit * (pageInfo.pageIndex-1)) + index+1}}</span>
                  <!-- <span class="text"> <span v-if="news.newNotice=='Y'" class="icon-new">NEW</span>{{news.newsCenterTitle}}</span> -->
                  <span class="text"><div class="news-title">{{news.newsCenterTitle}}</div><span v-if="news.newNotice == 'Y'" class="new">N</span></span>
                  <span class="date">{{news.newsCenterReg | date('yyyy. MM. dd')}}</span>
                </a>
              </li>
            </ul>
            <div v-else class="view int_prj"> 
              <div class="req none">등록된 뉴스가 없습니다.</div>
            </div>
          </div>          
            <!-- 페이징부분 -->
		    <paging-comp :pageInfo="pageInfo" @page-click="goPage"/>
        </div>
    </div>
</template>

<script>
import pagingComp from '@/components/PagingComp.vue';
import { newsMeta } from '@/utils/meta';

export default {
    metaInfo : newsMeta,

    components: { pagingComp },
    data() {
        return {
            input : {
                pageIndex: 1,
            },
            newsList : [],
            pageInfo: {},
        }
    },
    
    mounted() {
        this.getNewsList();
    },

    methods : {
        getNewsList() {
            this.$.httpPost('/api/main/bbs/getNewsList', this.input)
                .then(res => {
                    this.newsList = res.data.newsList;
                    this.pageInfo = res.data.pageInfo;
                }).catch(this.$.httpErrorCommon);
        },

        goNewsDetail(idx) {
            // this.$router.push({name: 'BBS003M02', params:{newsCenterSeq:idx}});
            this.$router.push({name: 'BBS003M02', query:{no : idx}});
        },

        goPage(page) {
			// console.log(page);
			this.input.pageIndex = page;
			this.getNewsList();
		},
    }
}
</script>